import React from 'react';

import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

import { doesTooltipNotHaveOwnerToDisplay } from '../../../app/spaces/Tooltips/Elements/Tooltip';
import { TooltipAnchor } from '../../../app/spaces/Tooltips/TooltipAnchor';
import { Messages } from '../../../codegen/Localize';
import { PredictiveModelTooltip } from '../tooltips/PredictiveModelTooltip';
import { PredictiveModelThumbnail } from './PredictiveModelThumbnail';

export class PredictiveModelCard extends ContentCard {
  public render() {
    const disableAutoFocus = doesTooltipNotHaveOwnerToDisplay(this.props.content);

    return (
      <div className={CardViewStyles.Card}>
        <TooltipAnchor
          tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          delay={0}
          title={Messages.predictiveModelTooltipTitle()}
          disableAutoFocus={disableAutoFocus}
          disableTooltip={this.props.disableTooltip}
        >
          <PredictiveModelThumbnail
            hoveredOrSelected={this.props.hoveredOrSelected}
            navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
            owner={this.props.content.owner}
            urls={this.props.urls}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName}>
            {this.props.content.name}
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }
  private renderTooltipContent = () => {
    return <PredictiveModelTooltip
      content={this.props.content}
      urls={this.props.urls} />;
  }
}
